import './lib/rails'
import './lib/jquery'
import './lib/bootstrap'
import './lib/toastr'

Rails.start()

import 'intl-tel-input/build/js/intlTelInput-jquery.min'

import Swiper from 'swiper'
window.Swiper = Swiper

import './controllers'

import './distributors/change_distributor_form'
import './helpers'
import './document_name'
import './hide_show_bonus_code_text'
import './input_files'
import './mobile_profile_nav'
import './subscription_expiration'
import './subscribe_modal'
import './users/profile'
import './redactor/redactor_config'

$(document).ready(function () {
  $('.auto-input').on('change', function () {
    var form = $(this).parents('form')[0]
    Rails.fire(form, 'submit')
  })

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  )
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl)
  })

  if ($('#distributorTermsModal').length > 0) {
    $('#distributorTermsModal').modal('show')
  }
})
